import { parentsDeepHasClassList } from '../vue/utlis/parentsDeepHasClassList';

/**
 * TODO this is legacy!!! needed checking for sideffects on vue components
 */
export default function initInputsFocus() {
	const inputs = Array.from(document.querySelectorAll('input'))
        // костыль - чтобы не влияло на некоторые vue компоненты
        .filter((input) => !parentsDeepHasClassList(input, ['ui-form-field', 'ui-image-box-switcher', 'ui-switcher'], 3));

	if (!inputs.length) return;

    const onFocus = (e) => {
        e.currentTarget.classList.add('_focus');
    }

    const onInput = (e) => {
        const input = e.currentTarget;
        if (input.value.length > 0) {
            input.classList.add('_focus');
        } else {
            input.classList.remove('_focus');
        }
    }

    const onBlur = (e) => {
        if (e.currentTarget.value.length == 0) {
            e.currentTarget.classList.remove('_focus');
        }
    }

	inputs.forEach((input) => {
        input.addEventListener('focus', onFocus);
        input.addEventListener('input', onInput);
        input.addEventListener('blur', onBlur);
	})
}
